import { BOT_DEPLOYMENTS_CHANNELS } from '../../../constants/main';
import BotDeploymentsMsTeamsStrategyGeneralForm from './MsTeams/BotDeploymentsMsTeamsStrategyGeneralForm';
import BotDeploymentsWebchatStrategyGeneralForm from './Webchat/BotDeploymentsWebchatStrategyGeneralForm';
import BotDeploymentsViberStrategyGeneralForm from './Viber/BotDeploymentsViberStrategyGeneralForm';
import BotDeploymentsFacebookStrategyGeneralForm from './Facebook/BotDeploymentsFacebookStrategyGeneralForm';
import BotDeploymentsSlackStrategyGeneralForm from './Slack/BotDeploymentsSlackStrategyGeneralForm';
import BotDeploymentsInstagramStrategyGeneralForm from './Instagram/BotDeploymentsInstagramStrategyGeneralForm';
import BotDeploymentsWhatsAppStrategyGeneralForm from './WhatsApp/BotDeploymentsWhatsAppStrategyGeneralForm';
import BotDeploymentsApiStrategyGeneralForm from './Api/BotDeploymentsApiStrategyGeneralForm';
import BotDeploymentsUnityStrategyGeneralForm from './Unity/BotDeploymentsUnityStrategyGeneralForm';

export const GeneralFormStrategies = {
  [BOT_DEPLOYMENTS_CHANNELS.MICROSOFT_TEAMS.key]: BotDeploymentsMsTeamsStrategyGeneralForm,
  [BOT_DEPLOYMENTS_CHANNELS.MICROSOFT_WEB_CHAT.key]: BotDeploymentsWebchatStrategyGeneralForm,
  [BOT_DEPLOYMENTS_CHANNELS.VIBER.key]: BotDeploymentsViberStrategyGeneralForm,
  [BOT_DEPLOYMENTS_CHANNELS.FACEBOOK.key]: BotDeploymentsFacebookStrategyGeneralForm,
  [BOT_DEPLOYMENTS_CHANNELS.SLACK.key]: BotDeploymentsSlackStrategyGeneralForm,
  [BOT_DEPLOYMENTS_CHANNELS.INSTAGRAM.key]: BotDeploymentsInstagramStrategyGeneralForm,
  [BOT_DEPLOYMENTS_CHANNELS.WHATSAPP.key]: BotDeploymentsWhatsAppStrategyGeneralForm,
  [BOT_DEPLOYMENTS_CHANNELS.API.key]: BotDeploymentsApiStrategyGeneralForm,
  [BOT_DEPLOYMENTS_CHANNELS.UNITY.key]: BotDeploymentsUnityStrategyGeneralForm
};
